import { Directive, Injector } from '@angular/core';

import { IWidgetConfig } from '../../../../framework/types';
import { BaseComponent } from '../../../base/base.component';
import { registerProps } from './dialog-footer.props';
import { provideAsWidgetRef } from '../../../../../utils/widget-utils';

const WIDGET_INFO: IWidgetConfig = {
    widgetType: 'wm-dialogfooter',
    hostClass: 'app-dialog-footer modal-footer'
};

@Directive({
    selector: 'div[wmDialogFooter]',
    providers: [
        provideAsWidgetRef(DialogFooterDirective)
    ]
})
export class DialogFooterDirective extends BaseComponent {
    static initializeProps = registerProps();

    constructor(inj: Injector) {
        super(inj, WIDGET_INFO);
    }
}
